import _ from 'underscore';
import PropTypes from 'prop-types';
import TaskName from '../task-name';

const TaskNameCell = ({ task, onClick, cadenceNameMap = {}, cadenceV2Enabled = false }) => {
  if (!task) return null;

  const { title, completed_at, metadata = {}, current_due_date, owner_info, contact = {} } = task;
  const attrs = contact?.contact_attributes;
  const contactName =
    attrs?.name_full?.trim() ||
    [attrs?.name_first, attrs?.name_last].filter(Boolean).join(' ').trim() ||
    attrs?.name_nick?.trim() ||
    '';

  let effectiveMetadata = metadata;

  // Build metadata for cadence v2 tasks so ActiveJourneyPill renders (only when flag is on)
  if (cadenceV2Enabled && task.task_source === 'cadence_v2' && task.cadence_id && _.isEmpty(metadata)) {
    const info = cadenceNameMap[task.cadence_id];
    const cadenceName = typeof info === 'object' ? info?.name : info || null;
    // Show blank while cadence names are loading — only show "Cadence Removed"
    // if the map has loaded and this cadence isn't in it (truly deleted).
    const mapLoaded = Object.keys(cadenceNameMap).length > 0;
    effectiveMetadata = {
      journey_id: task.cadence_id,
      journey_name: cadenceName || (mapLoaded ? 'Cadence Removed' : ''),
      task_source: 'cadence_v2',
    };
  }

  // Prepare metadata for TaskName component
  if (effectiveMetadata) {
    effectiveMetadata.current_due_date = current_due_date;
    effectiveMetadata.owner = owner_info;
  }

  return (
    <div className="task-name-cell">
      <div className="task-name-content">
        <TaskName
          title={title}
          completed_at={completed_at}
          metadata={effectiveMetadata}
          onClick={onClick}
          contactName={contactName}
        />
      </div>
    </div>
  );
};

TaskNameCell.propTypes = {
  task: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  cadenceNameMap: PropTypes.object,
  cadenceV2Enabled: PropTypes.bool,
};

export default TaskNameCell;
